import Cookies from "js-cookie";
import UAParser from "ua-parser-js";

import { ResponseData } from "./request";

export const errorMsg = (res: ResponseData): string => {
  return `${res.description || ""}`;
};

// app 内打开 跳转 app登录页
const pageToLogin = () => {
  const isInApp = checkIsInApp();
  if (isInApp) {
    window.location.href = "sensechat://login";
  } else {
    window.location.replace("/login");
  }
};

export const isInProd = BUSINESS_ENV.indexOf("prod") >= 0;

export const checkIsInApp = () => {
  const system_type = localStorage.getItem("system_type");
  const version_code = localStorage.getItem("version_code");
  return !!version_code && !!system_type;
};

export function delay(ms: number) {
  return new Promise(resolve => {
    setTimeout(resolve, ms);
  });
}

export const setCookie = (
  name: string,
  value: string,
  expiredays: number = 7,
) => {
  Cookies.set(name, encodeURIComponent(value), {
    expires: expiredays,
  });
  // localStorage.setItem(name, value);
};

//取回cookie
export const getCookie = (name: string) => {
  if (Cookies.get(name)) return decodeURIComponent(Cookies.get(name)!);
  // if (localStorage.getItem(name)) return localStorage.getItem(name);
  return "";
};

export const removeCookie = (name: string) => {
  Cookies.remove(name);
  // localStorage.removeItem(name);
};

export const removeAllCookies = () => {
  try {
    const allCookies = document.cookie.split(";");
    // set past expiry to all cookies
    for (let i = 0; i < allCookies.length; i++) {
      const splitIndex = allCookies[i].indexOf("=");
      let key = allCookies[i].slice(0, splitIndex);
      key = key.trim();
      document.cookie =
        key + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    }
  } catch (error) {
    console.warn(error);
  }
};

export const getRandomNumbersFromArray = ({
  arr,
  number = 4,
}: {
  arr: any;
  number?: number;
}) => {
  const result = new Array(number);
  const len = arr.length;
  let index = 0;
  if (number > len) {
    return null;
  }
  while (index < number) {
    const x = Math.floor(Math.random() * len);
    if (result.indexOf(arr[x]) === -1) {
      result[index] = arr[x];
      index++;
    }
  }
  return result;
};

export const getRandomItemsFromArray = ({
  arr,
  lines = 2,
  maxCount = 30,
}: {
  arr: string[];
  lines?: number;
  maxCount?: number;
}): string[][] => {
  let totalCount = 0;
  const len = arr.length;
  const takenIdxs: number[] = [];
  const result: string[][] = [];
  let lineIdx = 0;
  while (lineIdx < lines) {
    if (totalCount >= maxCount) {
      totalCount = 0;
      lineIdx++;
      continue;
    }
    const x = Math.floor(Math.random() * len);
    if (x in takenIdxs) continue;
    takenIdxs.push(x);
    if (result && result[lineIdx]) {
      result[lineIdx].push(arr[x]);
    } else {
      result[lineIdx] = [arr[x]];
    }
    totalCount += arr[x].length;
    console.log(totalCount, result);
  }
  return result;
};

// export const getWaterMarkContent = (): string => {
//   if (user && user.phone && user.phone.length > 4)
//     // return user.phone.slice(user.phone.length - 4, user.phone.length);
//     return (
//       user.phone.slice(0, 3) +
//       "****" +
//       user.phone.slice(user.phone.length - 4, user.phone.length)
//     );
//   return "";
// };

export function decodeHTMLEntities(str: string) {
  const element = document.createElement("textarea");
  element.innerHTML = str;
  return element.value;
}

const dpr = window.devicePixelRatio || 1;
export const imgSuffix = dpr === 1 ? "1x.png" : dpr === 2 ? "2x.png" : "3x.png";

export function validatePassword(password: string) {
  const hasLowercaseLetter = /[a-z]/.test(password);
  const hasCapitaLetter = /[A-Z]/.test(password);
  const hasDigit = /\d/.test(password);
  // const hasSpecialChar = /[@$!%*#?&]/.test(password);
  return hasLowercaseLetter && hasDigit && hasCapitaLetter;
}

// 生成模糊匹配正则 (.*?)(木)(.*?)(代)(.*)
export function genFuzzyMatchingReg(keyword: string): RegExp | null {
  const escapeReg = /[.*+\-?^${}()|[\]\\]/;
  const searchStr = keyword
    .split("")
    .map(s => (escapeReg.test(s) ? `([\\${s}])` : `(${s})`));
  if (searchStr.length) {
    // console.log('searchStr', searchStr)
    const str = "(.*?)";
    const regStr = `${str}${searchStr.join(str)}(.*)`; // 尾部必须使用贪婪匹配
    const reg = RegExp(regStr, "i");
    return reg;
  } else {
    return null;
  }
}

export function autoHeight(radio: number, padding: number) {
  const viewWidth =
    document.documentElement.clientWidth || document.body.clientWidth;
  return `${(viewWidth - padding) / radio}px`;
}

// 洗牌算法
export function shuffleArray(array: any[]) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1)); // 生成 0 到 i 之间的随机索引
    [array[i], array[j]] = [array[j], array[i]]; // 交换当前元素和随机位置的元素
  }
}

// 数字格式化(大于minLimit转为以unit为单位的字符串)
export const num2unit: (
  num: number,
  unit?: string,
  minLimit?: number,
  precision?: number,
) => string = (num, unit, minLimit = 10000, precision = 2) => {
  if (num <= minLimit) return `${num}`;

  let res = `${(num / minLimit).toFixed(precision)}`;
  if (!!precision) {
    while (res.includes(".") && (res.endsWith(".") || res.endsWith("0"))) {
      res = res.slice(0, -1);
    }
  }
  return `${res}${unit}`;
};

// 删除字符串中的br标签
export const removeBrTag = (str: string): string => {
  return str.replace(/\<br[ ]*\/{0,1}\>|[ ]{0,}/gi, "");
};

// 毫秒转换为天、时、分、秒
export const ms2Duration = (ms: number): string => {
  const HOUR = 1000 * 60 * 60;
  const day = parseInt(`${ms / (HOUR * 24)}`);
  const hour = parseInt(`${(ms % (HOUR * 24)) / HOUR}`);
  const minutes = parseInt(`${(ms % HOUR) / (1000 * 60)}`);
  const second = parseInt(`${(ms % (1000 * 60)) / 1000}`);

  let text = "";
  day && (text += `${day}天`);
  hour && (text += `${hour}小时`);
  minutes && (text += `${minutes}分钟`);
  second && (text += `${second}秒`);
  return text || "-";
};

export const preloadImage = (imageUrls: string[]) => {
  const loadIns = imageUrls.map(url => {
    return new Promise(resolve => {
      const img = new Image();
      img.onload = () => {
        console.log("1");
        resolve(true);
      };
      img.onerror = () => {
        resolve(true);
      };
      img.src = url;
    });
  });
  return Promise.all(loadIns);
};

export const copy = (text: string, onSuccess: () => void) => {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(text);
    onSuccess();
  } else {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    return new Promise<void>((resolve, reject) => {
      document.execCommand("copy") ? resolve() : reject(new Error("error"));
      textArea.remove();
    }).then(() => {
      onSuccess();
    });
  }
};

export const desensitize = (phone: string) => {
  return phone.length === 8
    ? phone.slice(0, 2) + "****" + phone.slice(-2)
    : phone.slice(0, 3) + "****" + phone.slice(-4);
};

// 提取字符串中的url
export const extractUrls = (str: string): string[] => {
  const reg =
    /(https?|http):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/g;
  const matches = str.match(reg);
  return matches ?? [];
};

// 替换字符串中的url为超链接
export const convertUlrToHTML = (str: string): string => {
  const reg =
    /(https?|http):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/g;
  const result = str.replace(reg, match => {
    return `<a class='demo_link' href="${match}" target="_blank">${match}</a>`;
  });
  return result;
};

// 分割字符串中的url 与字符
export const splitStrByUrl = (
  str: string,
): {
  type: "url" | "text";
  content: string;
}[] => {
  const reg =
    /((?:https?|http):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|])/g;
  const resList = str
    .split(reg)
    .filter(s => s !== "")
    .map(s => s.trim());

  return resList.map(s => ({
    type: reg.test(s) ? "url" : "text",
    content: s,
  }));
};

// 获取指定url对应的favicon title description
export const getHtmlInfoByUrl = async (
  url: string,
): Promise<
  { title: string; description: string; favicon: string } | undefined
> => {
  if (!url) return undefined;

  const response = await window.fetch(url, {
    method: "get",
  });
  const htmlText = await response.text();
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlText, "text/html");
  if (!doc) return undefined;

  // Extract the title
  const title = doc.querySelector("title")
    ? doc.querySelector("title")?.innerText || ""
    : "";

  // Extract the description
  const description = doc.querySelector('meta[name="description"]')
    ? doc.querySelector('meta[name="description"]')?.getAttribute("content") ||
      ""
    : "";

  // Extract the favicon
  let favicon = doc.querySelector('link[rel="icon"]');
  if (!favicon) {
    favicon = doc.querySelector('link[rel="shortcut icon"]');
  }
  const faviconUrl = favicon ? favicon.getAttribute("href") || "" : "";

  return {
    title: title,
    description: description,
    favicon: faviconUrl,
  };
};

// antd v5 css 兼容
export const antdCssHighPriority = (ua?: string): "low" | "high" => {
  const uaResult = UAParser(ua || navigator.userAgent);
  const { name, version } = uaResult.browser;
  console.log("broswer", name, version);
  if (!version || !name) return "low";

  const majorVersion = +version.split(".")[0];
  if (name.toLowerCase() === "chrome" && majorVersion < 88) {
    // 兼容360安全浏览器 v13、 chrome v88以下
    return "high";
  }

  return "low";
};
